<template>
   <div>
    <Slide width="200" >
      <router-link to="/About"><font-awesome-icon icon="home" /> ..About</router-link>
      <router-link to="/Objectives"><font-awesome-icon icon="bullseye" /> ..Objectives</router-link>
      <router-link to="/Events"><font-awesome-icon icon="calendar-check" /> ..Events</router-link>
      <router-link to="/Sponsor"><font-awesome-icon icon="hands-helping" /> ..Sponsor</router-link>
      <router-link to="/Gallery/PhotoGallery"><font-awesome-icon icon="images" /> ..Gallery</router-link>
      <router-link to="/Contact"><font-awesome-icon icon="mobile-alt" /> ..Contact</router-link>
    </Slide>          

   </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'

  export default {
    name: 'Slidemenu',
    components: {
    Slide
    },
    data () {
      return {
        msg: 'Slidemenu'
    }
  },
  methods: {
    
    }

}

</script>

<style> 
</style>


// WEBPACK FOOTER //
// src/components/sections/Slidemenu.vue